export const PLAYER_EVENT_PREFIX = 'livecommerce:';
export const PLAYER_EVENTS = {
  ACTION_CARD_CLICKED: `${PLAYER_EVENT_PREFIX}action-card-clicked`,
  ADD_TO_WISHLIST: `${PLAYER_EVENT_PREFIX}add-to-wishlist`,
  ADD_TO_CART: `${PLAYER_EVENT_PREFIX}should-add-item-to-cart`,
  APP_UNLOADED: `${PLAYER_EVENT_PREFIX}app-unloaded`,
  CHAT_MESSAGES: `${PLAYER_EVENT_PREFIX}chat-messages`,
  CHECKOUT: `${PLAYER_EVENT_PREFIX}goto-checkout`,
  CLOSE: `${PLAYER_EVENT_PREFIX}close`,
  CSS_OVERRIDES: `${PLAYER_EVENT_PREFIX}css-overrides`,
  CURRENT_BASEPAGE_SCROLLTOP: `${PLAYER_EVENT_PREFIX}current-basepage-scrolltop`,
  CURRENT_BASEPAGE_VIEWPORT: `${PLAYER_EVENT_PREFIX}current-basepage-viewport`,
  DO_SYNC_CART_STATE: `${PLAYER_EVENT_PREFIX}sync-cart-state`,
  ENTERED_PICTURE_IN_PICTURE: `${PLAYER_EVENT_PREFIX}entered-picture-in-picture`,
  EVENT_INFO_STATE: `${PLAYER_EVENT_PREFIX}event-info-state`,
  EXIT_PICTURE_IN_PICTURE: `${PLAYER_EVENT_PREFIX}exit-picture-in-picture`,
  EXITED_PICTURE_IN_PICTURE: `${PLAYER_EVENT_PREFIX}exited-picture-in-picture`,
  EXTERNAL_PLAYER_CONTROLLER_CHANGE: `${PLAYER_EVENT_PREFIX}external-player-controller-change`,
  EXTERNAL_PLAYER_CONTROLLER_CONTROLS: `${PLAYER_EVENT_PREFIX}external-player-controller-controls`,
  EXTERNAL_PLAYER_CONTROLLER_EVENTS: `${PLAYER_EVENT_PREFIX}external-player-controller-events`,
  EXTERNAL_PLAYER_CONTROLLER_HIDE: `${PLAYER_EVENT_PREFIX}external-player-controller-hide`,
  EXTERNAL_PLAYER_CONTROLLER_LOAD: `${PLAYER_EVENT_PREFIX}external-player-controller-load`,
  EXTERNAL_PLAYER_CONTROLLER_MUTE: `${PLAYER_EVENT_PREFIX}external-player-controller-mute`,
  EXTERNAL_PLAYER_CONTROLLER_NEW: `${PLAYER_EVENT_PREFIX}external-player-controller-new`,
  EXTERNAL_PLAYER_CONTROLLER_PAUSE: `${PLAYER_EVENT_PREFIX}external-player-controller-pause`,
  EXTERNAL_PLAYER_CONTROLLER_PLAY: `${PLAYER_EVENT_PREFIX}external-player-controller-play`,
  EXTERNAL_PLAYER_CONTROLLER_REMOVE: `${PLAYER_EVENT_PREFIX}external-player-controller-remove`,
  EXTERNAL_PLAYER_CONTROLLER_RESIZE: `${PLAYER_EVENT_PREFIX}external-player-controller-resize`,
  EXTERNAL_PLAYER_CONTROLLER_SCALE_MODE: `${PLAYER_EVENT_PREFIX}external-player-controller-scale-mode`,
  EXTERNAL_PLAYER_CONTROLLER_SEEK: `${PLAYER_EVENT_PREFIX}external-player-controller-seek`,
  EXTERNAL_PLAYER_CONTROLLER_SHOW: `${PLAYER_EVENT_PREFIX}external-player-controller-show`,
  EXTERNAL_PLAYER_CONTROLLER_PLAYBACK_SPEED: `${PLAYER_EVENT_PREFIX}external-player-controller-playback-speed`,
  FOCUS_FIRST_INSIDE_IFRAME: `${PLAYER_EVENT_PREFIX}focus-first-inside-iframe`,
  FOCUS_FIRST_OUTSIDE_IFRAME: `${PLAYER_EVENT_PREFIX}focus-first-outside-iframe`,
  FOCUS_LAST_INSIDE_IFRAME: `${PLAYER_EVENT_PREFIX}focus-last-inside-iframe`,
  FOCUS_LAST_OUTSIDE_IFRAME: `${PLAYER_EVENT_PREFIX}focus-last-outside-iframe`,
  FOCUS_LEAVE: `${PLAYER_EVENT_PREFIX}focus-leave`,
  FOCUS_WEB_COMPONENT_OUTSIDE_IFRAME: `${PLAYER_EVENT_PREFIX}focus-web-component-outside-iframe`,
  FULLSCREEN_ENTER: `${PLAYER_EVENT_PREFIX}fullscreen-enter`,
  FULLSCREEN_EXIT: `${PLAYER_EVENT_PREFIX}fullscreen-exit`,
  HIDE_CART: `${PLAYER_EVENT_PREFIX}should-hide-cart`,
  HIDE_CHAT_OVERLAY: `${PLAYER_EVENT_PREFIX}should-hide-chat-overlay`,
  HIDE_PRODUCT_LIST: `${PLAYER_EVENT_PREFIX}should-hide-product-list`,
  HIDE_PRODUCT_VIEW: `${PLAYER_EVENT_PREFIX}should-hide-product-view`,
  HIDE_UI: `${PLAYER_EVENT_PREFIX}should-hide-ui`,
  LOAD: `${PLAYER_EVENT_PREFIX}load`,
  LOAD_ERROR: `${PLAYER_EVENT_PREFIX}load-error`,
  MINI_PLAYER_DRAG_START: `${PLAYER_EVENT_PREFIX}mini-player-drag-start`,
  MINI_PLAYER_DRAG_END: `${PLAYER_EVENT_PREFIX}mini-player-drag-end`,
  MINI_PLAYER_MOVE: `${PLAYER_EVENT_PREFIX}mini-player-move`,
  MINI_PLAYER_RESTORE: `${PLAYER_EVENT_PREFIX}mini-player-restore`,
  MINIMIZE: `${PLAYER_EVENT_PREFIX}minimize`,
  MINIMIZED_ACTION_OVERLAY: `${PLAYER_EVENT_PREFIX}minimized-action-overlay`,
  // MUTE / UNMUTE are requests to mute/unmute the player
  // MUTED / UNMUTED are events which notify that the player has been muted/unmuted
  MUTE: `${PLAYER_EVENT_PREFIX}mute`,
  MUTED: `${PLAYER_EVENT_PREFIX}muted`,
  // SHOW_CAPTIONS / HIDE_CAPTIONS are requests to show/hide captions
  // CAPTIONS_SHOWN / CAPTIONS_HIDDEN are events which notify that captions have been shown/hidden
  SHOW_CAPTIONS: `${PLAYER_EVENT_PREFIX}show-captions`,
  HIDE_CAPTIONS: `${PLAYER_EVENT_PREFIX}hide-captions`,
  // ENABLE_HIGH_CONTRAST / DISABLE_HIGH_CONTRAST force the player's high-contrast
  // styling on/off (on top of the OS-level prefers-contrast: more media query).
  ENABLE_HIGH_CONTRAST: `${PLAYER_EVENT_PREFIX}enable-high-contrast`,
  DISABLE_HIGH_CONTRAST: `${PLAYER_EVENT_PREFIX}disable-high-contrast`,
  SELECT_CAPTION_TRACK: `${PLAYER_EVENT_PREFIX}select-caption-track`,
  GET_AVAILABLE_CAPTIONS: `${PLAYER_EVENT_PREFIX}get-available-captions`,
  CAPTIONS_SHOWN: `${PLAYER_EVENT_PREFIX}captions-shown`,
  CAPTIONS_HIDDEN: `${PLAYER_EVENT_PREFIX}captions-hidden`,
  CAPTION_TRACK_CHANGED: `${PLAYER_EVENT_PREFIX}caption-track-changed`,
  AVAILABLE_CAPTIONS: `${PLAYER_EVENT_PREFIX}available-captions`,
  NAVIGATE_BEHIND_TO: `${PLAYER_EVENT_PREFIX}navigate-behind-to`,
  NAVIGATION_SET_DEPTH: `${PLAYER_EVENT_PREFIX}navigation-set-depth`,
  NAVIGATION_GO_BACK: `${PLAYER_EVENT_PREFIX}navigation-go-back`,
  NOTIFY_URL_CHANGE: `${PLAYER_EVENT_PREFIX}notify-url-change`,
  ON_PROGRESS: `${PLAYER_EVENT_PREFIX}on-progress-update`,
  OPEN_EXTERNAL_BROWSER_SUCCESS: `${PLAYER_EVENT_PREFIX}open-external-browser-success`,
  OPEN_EXTERNAL_BROWSER: `${PLAYER_EVENT_PREFIX}open-external-browser`,
  OPEN_URL: `${PLAYER_EVENT_PREFIX}open-url`,
  OPEN_WISHLIST: `${PLAYER_EVENT_PREFIX}open-wishlist`,
  OPEN_WISHLIST_LOGIN: `${PLAYER_EVENT_PREFIX}open-wishlist-login`,
  PAUSE: `${PLAYER_EVENT_PREFIX}pause`,
  PLAY: `${PLAYER_EVENT_PREFIX}play`,
  PLAYBACK_STATUS: `${PLAYER_EVENT_PREFIX}playback-status`,
  PLAYER_CONTAINER_UPDATE: `${PLAYER_EVENT_PREFIX}player-container-update`,
  PLAYER_SWIPE_DOWN: `${PLAYER_EVENT_PREFIX}player-swipe-down`,
  PLAYER_SWIPE_LEFT: `${PLAYER_EVENT_PREFIX}player-swipe-left`,
  PLAYER_SWIPE_RIGHT: `${PLAYER_EVENT_PREFIX}player-swipe-right`,
  PLAYER_SWIPE_UP: `${PLAYER_EVENT_PREFIX}player-swipe-up`,
  PREVIEW_SHOULD_EXPAND: `${PLAYER_EVENT_PREFIX}preview-should-expand`,
  PRODUCT_HIGHLIGHT_LIST: `${PLAYER_EVENT_PREFIX}product-highlight-list`,
  PROVIDE_PRODUCT_DATA: `${PLAYER_EVENT_PREFIX}provide-product-data`,
  PROVIDE_WISHLIST_STATUS: `${PLAYER_EVENT_PREFIX}provide-wishlist-status`,
  PDP_APP_READY: `${PLAYER_EVENT_PREFIX}pdp-app-ready`,
  READY: `${PLAYER_EVENT_PREFIX}ready`,
  REMOVE_FROM_WISHLIST: `${PLAYER_EVENT_PREFIX}remove-from-wishlist`,
  REQUEST_EVENT_CHANGE: `${PLAYER_EVENT_PREFIX}request-event-change`,
  REQUEST_PICTURE_IN_PICTURE: `${PLAYER_EVENT_PREFIX}request-picture-in-picture`,
  RESET_BASE_PAGE_SCROLL: `${PLAYER_EVENT_PREFIX}reset-base-page-scroll`,
  RESPONSE: `${PLAYER_EVENT_PREFIX}response`,
  SEEK_TO_PERCENT: `${PLAYER_EVENT_PREFIX}seek-to-percent`,
  SET_APP_CONTEXT: `${PLAYER_EVENT_PREFIX}set-app-context`,
  SET_CLOSE_ICON: `${PLAYER_EVENT_PREFIX}set-close-icon`,
  SET_RESTORE_ICON: `${PLAYER_EVENT_PREFIX}set-restore-icon`,
  SET_ROOT_FONT_SIZE: `${PLAYER_EVENT_PREFIX}set-root-font-size`,
  SET_VIDEO_STATE: `${PLAYER_EVENT_PREFIX}set-video-state`,
  SET_VIEWPORT_STATE: `${PLAYER_EVENT_PREFIX}set-viewport-state`,
  SHOW_ADD_TO_CALENDAR: `${PLAYER_EVENT_PREFIX}should-show-add-to-calendar`,
  SHOW_CART: `${PLAYER_EVENT_PREFIX}should-show-cart`,
  SHOW_CHAT_OVERLAY: `${PLAYER_EVENT_PREFIX}should-show-chat-overlay`,
  SHOW_EMOJI_BATCH: `${PLAYER_EVENT_PREFIX}should-show-emoji-batch`,
  SHOW_PRODUCT_LIST: `${PLAYER_EVENT_PREFIX}should-show-product-list`,
  SHOW_PRODUCT_VIEW: `${PLAYER_EVENT_PREFIX}should-show-product-view`,
  SHOW_SHARE: `${PLAYER_EVENT_PREFIX}should-show-share`,
  SHOW_UI: `${PLAYER_EVENT_PREFIX}should-show-ui`,
  SUBSCRIBE: `${PLAYER_EVENT_PREFIX}subscribe`,
  SYNC_CART_STATE: `${PLAYER_EVENT_PREFIX}should-sync-cart-state`,
  THEME_UPDATE: `${PLAYER_EVENT_PREFIX}theme-update`,
  APPLY_THEME: `${PLAYER_EVENT_PREFIX}bambuser-theme-update`,
  TOP_UI_ELEMENT_HIDDEN: `${PLAYER_EVENT_PREFIX}top-ui-element-hidden`,
  TOP_UI_ELEMENT_SHOWN: `${PLAYER_EVENT_PREFIX}top-ui-element-shown`,
  TRACKING_POINT: `${PLAYER_EVENT_PREFIX}tracking-point`,
  TRACKING_SEND_EVENT: `${PLAYER_EVENT_PREFIX}tracking-send-event`,
  TRACKING_TAGS: `${PLAYER_EVENT_PREFIX}tracking-tags`,
  UNMUTE: `${PLAYER_EVENT_PREFIX}unmute`,
  UNMUTED: `${PLAYER_EVENT_PREFIX}unmuted`,
  UNSUBSCRIBE: `${PLAYER_EVENT_PREFIX}unsubscribe`,
  UPDATE_ITEM_IN_CART: `${PLAYER_EVENT_PREFIX}should-update-item-in-cart`,
  UPDATE_PRODUCT_HIGHLIGHT: `${PLAYER_EVENT_PREFIX}should-update-product-highlight`,
  UPDATE_SAFE_AREA_INSETS: `${PLAYER_EVENT_PREFIX}update-safe-area-insets`,
  UPDATE_SHOW_STATUS: `${PLAYER_EVENT_PREFIX}should-update-show-status`,
  SEO_SCHEMA_ANNOUNCEMENT: `${PLAYER_EVENT_PREFIX}seo-schema-announcement`,
};
export const PLAYER_EVENTS_PUBLIC = Object.entries(PLAYER_EVENTS).reduce((acc, [key, value]) => {
  acc[key] = value.replace(PLAYER_EVENT_PREFIX, '');
  return acc;
}, {});

export const SURF_FRAME_EVENT_PREFIX = 'livecommerce-surf:';
export const SURF_FRAME_EVENTS = {
  ACCEPTED_REQUEST_OPEN_SHOW: `${SURF_FRAME_EVENT_PREFIX}accepted-request-open-show`,
  REQUEST_OPEN_SHOW: `${SURF_FRAME_EVENT_PREFIX}request-open-show`,
};

export const PLAYER_BUTTON_BEHAVIORS = {
  AUTO: 'auto',
  CLOSE: 'close',
  INLINE: 'inline',
  LINK: 'link',
  MINIMIZE: 'minimize',
  NONE: 'none',
  EVENT: 'event',
};

export const PLAYER_CART_EVENTS = [
  PLAYER_EVENTS.ADD_TO_CART,
  PLAYER_EVENTS.CHECKOUT,
  PLAYER_EVENTS.PROVIDE_PRODUCT_DATA,
  PLAYER_EVENTS.UPDATE_ITEM_IN_CART,
];

export const PLAYER_UI_EVENTS = [
  PLAYER_EVENTS.ACTION_CARD_CLICKED,
  PLAYER_EVENTS.ADD_TO_WISHLIST,
  PLAYER_EVENTS.CHAT_MESSAGES,
  PLAYER_EVENTS.ENTERED_PICTURE_IN_PICTURE,
  PLAYER_EVENTS.EXITED_PICTURE_IN_PICTURE,
  PLAYER_EVENTS.FOCUS_WEB_COMPONENT_OUTSIDE_IFRAME,
  PLAYER_EVENTS.HIDE_CART,
  PLAYER_EVENTS.HIDE_CHAT_OVERLAY,
  PLAYER_EVENTS.HIDE_PRODUCT_LIST,
  PLAYER_EVENTS.HIDE_PRODUCT_VIEW,
  PLAYER_EVENTS.MUTED,
  PLAYER_EVENTS.NOTIFY_URL_CHANGE,
  PLAYER_EVENTS.OPEN_URL,
  PLAYER_EVENTS.OPEN_WISHLIST,
  PLAYER_EVENTS.OPEN_WISHLIST_LOGIN,
  PLAYER_EVENTS.PLAYBACK_STATUS,
  PLAYER_EVENTS.PLAYER_CONTAINER_UPDATE,
  PLAYER_EVENTS.PLAYER_SWIPE_DOWN,
  PLAYER_EVENTS.PLAYER_SWIPE_LEFT,
  PLAYER_EVENTS.PLAYER_SWIPE_RIGHT,
  PLAYER_EVENTS.PLAYER_SWIPE_UP,
  PLAYER_EVENTS.PREVIEW_SHOULD_EXPAND,
  PLAYER_EVENTS.PROVIDE_WISHLIST_STATUS,
  PLAYER_EVENTS.REMOVE_FROM_WISHLIST,
  PLAYER_EVENTS.SHOW_ADD_TO_CALENDAR,
  PLAYER_EVENTS.SHOW_CART,
  PLAYER_EVENTS.SHOW_CHAT_OVERLAY,
  PLAYER_EVENTS.SHOW_EMOJI_BATCH,
  PLAYER_EVENTS.SHOW_PRODUCT_LIST,
  PLAYER_EVENTS.SHOW_PRODUCT_VIEW,
  PLAYER_EVENTS.SHOW_SHARE,
  PLAYER_EVENTS.SUBSCRIBE,
  PLAYER_EVENTS.TOP_UI_ELEMENT_HIDDEN,
  PLAYER_EVENTS.TOP_UI_ELEMENT_SHOWN,
  PLAYER_EVENTS.UNMUTED,
  PLAYER_EVENTS.CAPTIONS_SHOWN,
  PLAYER_EVENTS.CAPTIONS_HIDDEN,
  PLAYER_EVENTS.CAPTION_TRACK_CHANGED,
  PLAYER_EVENTS.UNSUBSCRIBE,
  PLAYER_EVENTS.UPDATE_PRODUCT_HIGHLIGHT,
  PLAYER_EVENTS.UPDATE_SHOW_STATUS,
];

export const PLAYER_MISC_EVENTS = [
  PLAYER_EVENTS.LOAD,
  PLAYER_EVENTS.LOAD_ERROR,
];

export const EXTERNAL_PLAYER_EVENTS = [
  PLAYER_EVENTS.EXTERNAL_PLAYER_CONTROLLER_CONTROLS,
  PLAYER_EVENTS.EXTERNAL_PLAYER_CONTROLLER_HIDE,
  PLAYER_EVENTS.EXTERNAL_PLAYER_CONTROLLER_LOAD,
  PLAYER_EVENTS.EXTERNAL_PLAYER_CONTROLLER_MUTE,
  PLAYER_EVENTS.EXTERNAL_PLAYER_CONTROLLER_NEW,
  PLAYER_EVENTS.EXTERNAL_PLAYER_CONTROLLER_PAUSE,
  PLAYER_EVENTS.EXTERNAL_PLAYER_CONTROLLER_PLAY,
  PLAYER_EVENTS.EXTERNAL_PLAYER_CONTROLLER_REMOVE,
  PLAYER_EVENTS.EXTERNAL_PLAYER_CONTROLLER_RESIZE,
  PLAYER_EVENTS.EXTERNAL_PLAYER_CONTROLLER_SCALE_MODE,
  PLAYER_EVENTS.EXTERNAL_PLAYER_CONTROLLER_SEEK,
  PLAYER_EVENTS.EXTERNAL_PLAYER_CONTROLLER_SHOW,
  PLAYER_EVENTS.EXTERNAL_PLAYER_CONTROLLER_PLAYBACK_SPEED,
];

export const PLAYER_EVENTS_TO_FORWARD = [
  ...PLAYER_CART_EVENTS,
  ...PLAYER_UI_EVENTS,
  ...PLAYER_MISC_EVENTS,
  ...EXTERNAL_PLAYER_EVENTS,
];

export const FLOATING_PLAYER_NAVIGATION_MODES = {
  IFRAME: 'iframe',
  MANUAL: 'manual',
};

export const GA_MEASUREMENT_ID = { STAGE: 'G-2GD03VB4T7', PROD: 'G-MY3DDVP96E' };
export const BAMLS = '_bamls';

/**
 * Defines names of tracking cookies
 */
export const TRACKING_COOKIES = {
  CUSTOMER_ID: `${BAMLS}_cuid`,
  LAST_INTERACTION_TIMESTAMP: `${BAMLS}_lits`,
  SESSION_ID: `${BAMLS}_seid`,
  SHOW_ID: `${BAMLS}_shid`,
  USER_ID: `${BAMLS}_usid`,
  LOCALIZED_CONVERSION_TRACKING_EXPIRY: `${BAMLS}_lcte`,
};

export const ORIENTATION = {
  EAST: 'E',
  NORTH_EAST: 'NE',
  NORTH_WEST: 'NW',
  NORTH: 'N',
  SOUTH_EAST: 'SE',
  SOUTH_WEST: 'SW',
  SOUTH: 'S',
  WEST: 'W',
};

export const MINIMIZED_POSITION = {
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right', // default
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
};

export const MINIPLAYER_SIZE = {
  SMALL: 'small',
  LARGE: 'large',
};

export const VIDEO_ORIENTATION = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
};
